import getFloorTradeBuiltElementCounts from "../../services/getters/project_getters/get_floor_trade_built_element_counts";
import loadFloorTradeBuiltElementCounts from "../../actions/dashboard/load_floor_trade_built_element_counts";
import useQueryWithState from "../use_query_with_state";

const useFloorTradeBuiltElementCounts = (projectId: string, enabled: boolean = true) => {
  return useQueryWithState(
    ["useFloorTradeBuiltElementCounts", projectId],
    loadFloorTradeBuiltElementCounts,
    getFloorTradeBuiltElementCounts,
    { enabled: enabled && !!projectId, refetchOnMount: "always" },
    { projectId },
    projectId
  );
};

export default useFloorTradeBuiltElementCounts;
